export default "__VITE_ASSET__BhgieWa___"